const goToTop = () => {
  const rcRoot = document.getElementById('rcroot');
  setTimeout(() => {
    const offset = 90; // pixels from top
    const elementPosition = rcRoot.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }, 1);
};

export default goToTop;
